
import { Prop, Component, Vue, Getter } from 'nuxt-property-decorator';
import Swiper, { A11y, Navigation, Pagination } from 'swiper';
import { IPoster } from 'src/types/collections';
import 'swiper/swiper-bundle.css';
import { PosterOverview } from '~/types/collections';

@Component({
  components: {},
})
export default class ProjectExpansionsPosters extends Vue {
  @Prop(Array) readonly posters!: PosterOverview[];
  @Prop(String) readonly slug!: string;

  getRedirectUrl(posterItem: PosterOverview) {
    return `/collection/${this.slug}/poster/${posterItem.posterId}`;
  }

  truncate(text: string, len: number = 24) {
    const string = text.substring(0, len) + (text.length > len ? '...' : '');
    return string;
  }

  get slideWidth() {
    return 400;
  }

  get aspectRatio() {
    return 1;
  }

  mounted() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const el = this.$refs?.swiperContainer as HTMLElement;
    if (!el) {
      return;
    }

    const posterSwiper = new Swiper(el, {
      slidesPerView: 'auto',
      modules: [A11y, Navigation, Pagination],
      navigation: {
        nextEl: `#${this.$id('next-btn')}`,
        prevEl: `#${this.$id('prev-btn')}`,
      },
      allowTouchMove: false,
      a11y: {
        nextSlideMessage: this.$t(
          'components.films.filmMediaTab.nextSlide',
        ) as string,
        prevSlideMessage: this.$t(
          'components.films.filmMediaTab.prevSlide',
        ) as string,
        paginationBulletMessage: this.$t(
          'components.films.filmMediaTab.goToSlide',
          { i: '{{index}}' },
        ) as string,
        slideLabelMessage: this.$t('components.films.filmMediaTab.slideLabel', {
          current: '{{index}}',
          total: '{{slidesLength}}',
        }) as string,
      },
    });
  }
}
